const parseVenmoHandleFromUrl = (url: string | null): string | null => {
	if (!url) return "";
	const handle = url.split("/u/")[1];
	return handle ?? null;
};

export default parseVenmoHandleFromUrl;
